import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabs } from '@shared/hooks';
import { AccountType } from '@shared/api/rest/accounts';
import { ReportDepositTab, ReportCreditTab } from './widgets';
import { NoData, PageContainer, Spinner, Tabs } from '@shared/widgets';

export const ReportsPage = () => {
  const tabsState = useTabs();

  const { t } = useTranslation('reports');

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <ReportDepositTab />;
    else if (tabsState.tab === AccountType.Card) return <ReportCreditTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.hasCard && tabsState.hasPayment && (
        <Tabs options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
      )}
      {currentTabView}
    </PageContainer>
  );
};
